module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/lodash/extend.js
// module id = 1076
// module chunks = 1